// extracted by mini-css-extract-plugin
export default {"addNewService":"AddNewTour_addNewService__CSXhx","textArea":"AddNewTour_textArea__Qa2Yf","label":"AddNewTour_label__pKeZV","formSubmitBtn":"AddNewTour_formSubmitBtn__z5yt-"};